import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-n404',
  templateUrl: './n404.component.html',
  styleUrls: ['./n404.component.scss']
})
export class N404Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
